import { Link, useLocation } from 'react-router-dom';
import { Home, Grid3X3, ShoppingCart, Receipt, Phone } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import { cn } from '@/lib/utils';

const SUPPORT_PHONE = '+919603540072';

export function BottomNav() {
  const location = useLocation();
  const { cartCount } = useCart();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/products', icon: Grid3X3, label: 'Shop' },
    { path: '/my-orders', icon: Receipt, label: 'Orders' },
    { path: '/cart', icon: ShoppingCart, label: 'Cart', badge: cartCount },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-border z-50 md:hidden shadow-[0_-4px_12px_rgba(0,0,0,0.06)]"
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));

          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={cn(
                'flex flex-col items-center justify-center flex-1 h-full relative transition-colors',
                isActive ? 'text-primary' : 'text-muted-foreground'
              )}
            >
              <div className="relative">
                <item.icon className="w-6 h-6" strokeWidth={isActive ? 2.5 : 2} />
                {item.badge > 0 && (
                  <span className="absolute -top-2 -right-2 bg-accent text-accent-foreground text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center cart-badge">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className="text-[11px] mt-1 font-semibold">{item.label}</span>
            </Link>
          );
        })}
        <a
          href={`tel:${SUPPORT_PHONE}`}
          data-testid="nav-call"
          className="flex flex-col items-center justify-center flex-1 h-full text-primary"
        >
          <Phone className="w-6 h-6" strokeWidth={2.2} />
          <span className="text-[11px] mt-1 font-semibold">Call</span>
        </a>
      </div>
    </nav>
  );
}
